import React from 'react';
import RRuleGenerator from 'react-rrule-generator';
import ShadowRoot from 'react-shadow';

import { bootstrapCSS } from './bootstrapCss';

import 'react-rrule-generator/build/styles.css';

class RRuleComponent extends React.Component {
    handleChange = RRule => {
        this.props.onChange(RRule);
    }

    render() {
        const { value } = this.props;

        return (
            <ShadowRoot.div>
                <style type="text/css">
                    {bootstrapCSS}
                </style>
                <RRuleGenerator
                    config={{
                        repeat: [ "Daily", "Weekly", "Monthly" ],
                        weekStartsOnSunday: false,
                        monthly: 'on',
                        hideError: true,
                        hideStart: true
                    }}
                    onChange={this.handleChange}
                    value={value}
                />
            </ShadowRoot.div>
        );
    }
}

export default RRuleComponent;